// Real operating entity details for LeadXchange
export const COMPANY = {
  legalName: 'Precision International Trading Pty Ltd',
  tradingAs: 'LeadXchange',
  abn: '41 687 738 610',
  abnDigits: '41687738610',
  jurisdiction: 'Western Australia, Australia',
  supportEmail: 'support@leadxchange.com.au',
  privacyEmail: 'privacy@leadxchange.com.au',
  statusEmail: 'status@leadxchange.com.au',
  disputeEmail: 'disputes@leadxchange.com.au',
  website: 'leadxchange.com.au',
};
